import { Chakra } from "@airhelp/react-ui-components";
import CircularProgress from "components/CircularProgress";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { DynamicComponent } from "modules/storyblok/DynamicComponent";
import type { FeeModelCardProps } from "./FeeModelCard.d";
import { FeeModelCardContentStyles, FeeModelCardSHeadingStyles } from "./FeeModelCard.styles";

const { Box, VStack, ListItem, Flex, Text } = Chakra;

const FeeModelCard = ({ heading, receiveValue, content, action = [], chartValue }: FeeModelCardProps) => {
  const translation = useTranslations();
  const lang = useLanguage();

  const boxHeight =
    (["de", "de-at", "de-ch", "nb"].includes(lang) && "116px") ||
    (["es", "el", "pt-pt", "fr", "fr-be", "fr-ca", "it", "nl", "pl", "ru", "ro", "sv"].includes(lang) && 20) ||
    "unset";

  return (
    <ListItem
      d="flex"
      flexDir="column"
      p={{ base: 4, lg: 6 }}
      bg="greyscale.100"
      border="1px"
      borderRadius="lg"
      borderColor="greyscale.400"
      flex={1}
    >
      <Flex minH={{ base: "unset", md: boxHeight }} alignItems="center" justifyContent="center">
        <RichtextAdapter content={heading} customStyles={FeeModelCardSHeadingStyles} />
      </Flex>
      {receiveValue && (
        <Text align="center" color="greyscale.500" fontSize="md" mb={2}>
          {`${translation("you_receive")}: `}
          <Text as="span" color="primary.900" fontSize="md" fontWeight="medium">
            {receiveValue}
          </Text>
        </Text>
      )}

      <Box mx="auto">
        <CircularProgress progressValue={chartValue} />
      </Box>

      <RichtextAdapter content={content} customStyles={FeeModelCardContentStyles} />

      {action.length > 0 && (
        <VStack spacing={8} alignItems="stretch" mt="auto" pt={{ base: 6, lg: 9 }}>
          {action.map((item) => (
            <DynamicComponent key={item._uid} blok={item} />
          ))}
        </VStack>
      )}
    </ListItem>
  );
};

export default FeeModelCard;
